import css from 'styled-jsx/css'

const staticStyles = css`
  .ResendEmailConfirmationForm {
    text-align: left;
  }

  .ResendEmailConfirmationForm__button-inner {
    text-align: center;
  }
`

export { staticStyles }

